module.exports = __webpack_public_path__ + "img/gharnaksha_logo.ffa7dece.png";